// token-alert-v1: banner แจ้งเตือน token ที่ใช้ไม่ได้
import React, { useEffect, useState } from 'react';
import API from '../api';

const POLL_MS = 60_000;

export default function TokenHealthBanner() {
  const [alerts, setAlerts] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  // banner นี้แสดงเฉพาะถ้า user login แบบปกติ (มี token ใน localStorage)
  // ใน super admin จะแสดงผ่าน TokenHealthCard ใน SuperAdmin.js
  const hasToken = typeof window !== 'undefined' && localStorage.getItem('token');

  async function load() {
    if (!hasToken) return;
    try {
      const { data } = await API.get('/api/token-health/alerts?unackOnly=true&limit=10');
      if (data?.success) setAlerts(data.data || []);
    } catch (e) {
      // 401 = ไม่มีสิทธิ์ → silent
      if (e?.response?.status !== 401) console.error('TokenHealthBanner', e);
    }
  }

  useEffect(() => {
    load();
    const id = setInterval(load, POLL_MS);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function ack(id) {
    try {
      await API.post(`/api/token-health/alerts/${id}/ack`);
      setAlerts((prev) => prev.filter((a) => a.id !== id));
    } catch (e) {
      console.error('ack', e);
    }
  }

  if (!hasToken || alerts.length === 0) return null;

  const critical = alerts.filter((a) => a.severity === 'critical').length;
  const warning = alerts.filter((a) => a.severity === 'warning').length;
  const headline = critical > 0
    ? `🚨 มี ${critical} Token ใช้งานไม่ได้`
    : `⚠️ ${warning} แจ้งเตือน Token`;

  return (
    <div style={{
      background: critical > 0 ? '#fee2e2' : '#fef3c7',
      borderBottom: `2px solid ${critical > 0 ? '#dc2626' : '#f59e0b'}`,
      padding: '8px 14px',
      fontSize: 13,
      position: 'relative',
      zIndex: 80,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <strong style={{ color: critical > 0 ? '#991b1b' : '#92400e' }}>
          {headline}
        </strong>
        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{
            background: 'transparent', border: 'none', cursor: 'pointer',
            color: '#374151', textDecoration: 'underline', fontSize: 12,
          }}
        >
          {collapsed ? 'แสดงรายละเอียด' : 'ซ่อน'}
        </button>
      </div>

      {!collapsed && (
        <ul style={{ margin: '6px 0 0 0', padding: 0, listStyle: 'none' }}>
          {alerts.map((a) => (
            <li key={a.id} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '5px 0', borderTop: '1px solid rgba(0,0,0,0.08)', gap: 8, flexWrap: 'wrap',
            }}>
              <div style={{ flex: 1, minWidth: 200 }}>
                <span style={{
                  display: 'inline-block', fontSize: 10, padding: '2px 6px',
                  borderRadius: 4, background: a.severity === 'critical' ? '#dc2626' : '#f59e0b',
                  color: 'white', marginRight: 6, fontWeight: 600,
                }}>
                  {(a.service || '').toUpperCase()}
                </span>
                <span style={{ color: '#1f2937' }}>{a.message}</span>
                {a.tenant_name && (
                  <span style={{ color: '#6b7280', marginLeft: 6 }}>· {a.tenant_name}</span>
                )}
              </div>
              <button
                onClick={() => ack(a.id)}
                style={{
                  background: 'white', border: '1px solid #d1d5db',
                  padding: '3px 10px', borderRadius: 4, cursor: 'pointer',
                  fontSize: 11, color: '#374151',
                }}
              >
                รับทราบ
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
